import AOS from 'aos';
import 'aos/dist/aos.css';
import React, { useEffect } from "react";
import myImage from "../../Images/IMG_0005.png";
import "./About.css";
const AboutMe = () => {
  useEffect(()=>{
    AOS.init({duration:2000});
  },[])
  return (
    <section data-aos="fade-right" id="about" className="about-mf pt-5">
      <div className="container">
        <div className="row">
          <div className="col-sm-12">
            <div className="title-box text-center">
              <h3 className="title-a">ABOUT ME</h3>
              <div className="line-mf"></div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
            <div className="box-shadow-full">
              <div className="row">
                <div className="col-md-6">
                  <div className="row">
                    <div className="col-sm-6 col-md-5">
                      <div className="about-img">
                        <img
                          src={myImage}
                          className="img-fluid rounded b-shadow-a"
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="col-sm-6 col-md-7">
                      <div className="about-info">
                        <p>
                          <span className="title-s">Name: </span>{" "}
                          <span>Minhazur Rahman Rafi</span>
                        </p>
                        <p>
                          <span className="title-s">Profile: </span>{" "}
                          <span>full stack developer</span>
                        </p>
                        <p>
                          <span className="title-s">Email: </span>{" "}
                          <span>rafi.rahman03@gmail.com</span>
                        </p>
                        <p>
                          <span className="title-s">Phone: </span>{" "}
                          <span>+8801686-823262</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="about-me pt-4 pt-md-0">
                    <p className="lead">
                    A full-stack developer specialized in frontend and backend development for complex scalable web apps. I enjoy using my obsessive attention to detail, my unequivocal love for making things, and my mission-driven work ethic to literally change the world. That's why I’m excited to make a big impact at a high growth company. 
                    </p>
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutMe;
